const ANALYTICS_ATTRIBUTION_VALUE_MAX_LENGTH = 512;

/** Shared browser-side wire rule for UTM and paid-click identifier values. */
export function normalizeAnalyticsAttributionValue(value: string | null | undefined): string | undefined {
  const normalized = value?.trim();
  return normalized &&
    normalized.length <= ANALYTICS_ATTRIBUTION_VALUE_MAX_LENGTH &&
    !containsControlCharacter(normalized)
    ? normalized
    : undefined;
}

export function isCanonicalAnalyticsAttributionValue(value: unknown): value is string {
  return typeof value === "string" && normalizeAnalyticsAttributionValue(value) === value;
}

function containsControlCharacter(value: string): boolean {
  return Array.from(value).some((character) => {
    const codePoint = character.codePointAt(0);
    return codePoint !== undefined && (codePoint <= 0x1f || (codePoint >= 0x7f && codePoint <= 0x9f));
  });
}
